import { Reveal } from "./Reveal";
import { GoogleStars } from "./GoogleStars";
import { trackEvent } from "../lib/tracking";
import {
  GOOGLE_PROFILE_URL,
  GOOGLE_RATING,
  GOOGLE_REVIEW_COUNT,
} from "../lib/googleReviews";

// Premium trust strip directly under the hero: five equal-width facts a
// first-time (often paid-search) visitor needs inside five seconds. Pure
// typography — no cards, no badges, no widgets. Four items link to their
// authority page; the stage indicator stays a non-link.
const ITEMS = [
  { label: "Certified Pediatric Sleep Consultant", href: "/pediatric-sleep-consultant" },
  {
    label: `${GOOGLE_RATING} Google · ${GOOGLE_REVIEW_COUNT} Reviews`,
    href: GOOGLE_PROFILE_URL,
    external: true,
    stars: true,
  },
  { label: "Newborn · Infant · Toddler" },
  { label: "Virtual Nationwide", href: "/virtual-sleep-consultant", event: "virtual_service_click" },
  { label: "In-Home Denver", href: "/denver-in-home-sleep-consultant", event: "in_home_service_click" },
];

const TEXT_CLS =
  "text-[11px] tracking-[0.22em] uppercase font-semibold text-smoke";

export const TrustStrip = () => (
  <section
    aria-label="Credentials at a glance"
    data-testid="trust-strip"
    className="bg-ivory border-b border-ink/10"
  >
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-6">
      <Reveal>
        <ul className="grid grid-cols-2 md:grid-cols-5 gap-y-5 md:gap-y-0 md:divide-x md:divide-ink/10">
          {ITEMS.map((item, i) => (
            <li
              key={item.label}
              data-testid={`trust-item-${i}`}
              className={`flex items-center justify-center text-center px-4 ${
                i === ITEMS.length - 1 ? "col-span-2 md:col-span-1" : ""
              }`}
            >
              {item.href ? (
                <a
                  href={item.href}
                  {...(item.external
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  onClick={() => {
                    if (item.external)
                      trackEvent("google_reviews_click", { location: "trust_strip" });
                    if (item.event)
                      trackEvent(item.event, { location: "trust_strip" });
                  }}
                  className={`${TEXT_CLS} inline-flex items-center justify-center gap-1.5 py-1 transition-colors hover:text-ink hover:underline underline-offset-4 decoration-clay/60`}
                >
                  {item.stars && <GoogleStars size={10} />}
                  {item.label}
                </a>
              ) : (
                <span
                  className={`${TEXT_CLS} inline-flex items-center justify-center gap-1.5 py-1`}
                >
                  {item.stars && <GoogleStars size={10} />}
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
